import { Load } from '../load';
import { Box3, Object3D, Vector3 } from "three";

export function calculateRotatedObjectData(load: Load | Object3D): Partial<Load> {
  const size: Vector3 = new Vector3();
  const pos: Vector3 = new Vector3();
  const boundingBox = new Box3().setFromObject(load);
  boundingBox.getSize(size);
  boundingBox.getCenter(pos);
  return {
    width: size.x,
    height: size.y,
    length: size.z,
    position: new Vector3(pos.x - size.x / 2, pos.y - size.y / 2, pos.z - size.z / 2),
  };
}
